import axios from "../utils/axios.wrapper";

export const getUnits = async () => {
  const { data } = await axios.get("/unit");
  return data.items || data;
};

export const getActiveUnits = async () => {
  const { data } = await axios.get("/unit/active");
  return data.items || data;
};

export const getInactiveUnits = async () => {
  const { data } = await axios.get("/unit/inactive");
  return data.items || data;
};

export const getUnitById = async (id) => {
  const { data } = await axios.get(`/unit/${id}`);
  return data;
};

export const getUnitByName = async (name) => {
  const { data } = await axios.get(`/unit/name/${name}`);
  return data;
};

export const createUnit = async (unit) => {
  const { data } = await axios.post("/unit/create", unit);
  return data;
};

export const updateUnit = async (id, unit) => {
  const { data } = await axios.put(`/unit/${id}`, unit);
  return data;
};

export const deleteUnit = async (id) => {
  const { data } = await axios.delete(`/unit/${id}`);
  return data;
};

export const hardDeleteUnit = async (id) => {
  const { data } = await axios.delete(`/unit/hard/${id}`);
  return data;
};

export const unitService = {
  getUnits,
  getActiveUnits,
  getInactiveUnits,
  getUnitById,
  getUnitByName,
  createUnit,
  updateUnit,
  deleteUnit,
  hardDeleteUnit,
};